import { Crisp } from "crisp-sdk-web";

export const TABLET_MODE_STORAGE_KEY = "reva-planillero-tablet-mode";
export const TABLET_CHROME_EVENT = "reva-planillero-tablet-chrome";
export const TABLET_BODY_CLASS = "reva-planillero-tablet";

export const readTabletModePreference = () => {
  try {
    return localStorage.getItem(TABLET_MODE_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setPlanilleroTabletChrome = (enabled) => {
  if (typeof document !== "undefined") {
    document.body.classList.toggle(TABLET_BODY_CLASS, enabled);
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(TABLET_CHROME_EVENT, { detail: enabled }));
  }

  try {
    if (enabled) {
      Crisp.chat.hide();
    } else {
      Crisp.chat.show();
    }
  } catch {
    // Crisp may not be loaded yet
  }
};
